import { render } from "./index.vue?vue&type=template&id=1f32ae50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=1f32ae50&scoped=true&lang=less"

import exportComponent from "/Users/zhanghao/Documents/beijing/maidong/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f32ae50"]])

export default __exports__